import axios from 'axios';
import { handleApiError } from './error';

const createApiClient = (authToken = null) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_UAT_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_UAT_X_API_KEY,
            ...(authToken && { 'Authorization': `Bearer ${authToken}` })
        },
    });

    // Add response interceptor
    client.interceptors.response.use(
        response => response,
        error => {            
            if (!error.response) {
                console.error('Network Error:', error.message);
            } else {
                var errorRes = handleApiError(error);
                console.log("errorRes",errorRes);
            }
            return Promise.reject(error);
        }
    );

    return client;
};

export default createApiClient;